export const environment = {
  production: true,
  apiEndPoint:'https://otcapi-staging.blockoville.com/apiroute/',
  recaptchsitekey: '6Lf93rAZAAAAAMz4b_YGO8T6R35NwaR8MsJHnVo4',
  imageapiendpoint:'https://otcapi-staging.blockoville.com/apiroute/uploads/',
  S3_BUCKET_URL: 'https://blockoville-otc.s3.eu-central-1.amazonaws.com/',
  adminConfigurlNew: "",
  pusher: {
    channel: "blockoville",
    channelprice: "blockovillePrice",
    key: "c687297ff4dbb7d677ae",
    cluster: "ap2",
  },
  TOKEN_SECRET: "adm76HFJnasFFFgavawa321",
  name:'test'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts